export const ContactModalAction = (params) => (dispatch, getState) => {
  dispatch({ type: params.type, payload: params.payload });
};